/**
 * Reducer to update the screen name in photo capture state
 * @param state - Current photo capture state
 * @param action - Action containing the new screen name
 * @returns Updated photo capture state with new screen name
 */
export const photoCaptureSetScreenNameReducer = (state, action) => {
    const { screenName } = action.payload;
    return Object.assign(Object.assign({}, state), { screenName });
};
//# sourceMappingURL=photoCaptureSetScreenNameReducer.js.map